import { deleteManualCheckAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteManualCheckSlice, asyncAction: deleteManualCheckAction } = createAsyncSlice(
  'deleteManualCheckSlice',
  deleteManualCheckAsync
);
